import { useEffect } from 'react';
import { Form, FormItem, Input } from '@packages/utils';
import dayjs from 'dayjs';
import { dateTimeFormatUI, timepickerFormat } from 'helpers/utils';
import { DatePicker } from 'components/Base/DatePicker';
import { RadioGroup, Radio } from 'components/Base/RadioGroup';
import useGetFormData from './AddEditMeetingForm.data';
import { TAddEditMeetingFormProps } from './AddEditMeetingForm.types';

const AddEditMeetingForm = ({
  form,
  initialValues,
  showPmIncludeOptions,
  isEditMode,
  open,
}: TAddEditMeetingFormProps) => {
  const { addEditMeetingFormFields } = useGetFormData();
  const { date, title } = addEditMeetingFormFields;

  useEffect(() => {
    if (!open || !initialValues) {
      return;
    }

    form.setFieldsValue({
      title: initialValues.title,
      date: dayjs(initialValues.date),
      scope: initialValues.scope,
    });
  }, [open, initialValues, form]);

  return (
    <Form form={form}>
      <FormItem {...title}>
        <Input
          placeholder={title.placeholder}
          maxLength={250}
          data-cy="meeting_note_input"
        />
      </FormItem>
      <FormItem {...date}>
        <DatePicker
          showTime={{
            minuteStep: 15,
            format: timepickerFormat,
          }}
          className="w-100"
          placeholder={date.placeholder}
          format={dateTimeFormatUI}
          data-cy="meeting_date_input"
        />
      </FormItem>
      {showPmIncludeOptions && (
        <FormItem name="scope" style={{ marginBottom: 0 }}>
          <RadioGroup
            key={`radio-${open}-${initialValues?.scope}`}
            style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
            disabled={isEditMode}
            data-cy="meeting_scope_radio_group"
          >
            <Radio value="ALL_ELCS" data-cy="all_elcs_radio">
              Include all ELC PMs
            </Radio>
            <Radio value="USER_LEAD_ELCS" data-cy="my_elcs_radio">
              Include my ELC PMs only
            </Radio>
          </RadioGroup>
        </FormItem>
      )}
    </Form>
  );
};

export default AddEditMeetingForm;
